import api from './api';

export const trialCentresService = {
  // Get all trial centres with pagination and filtering
  async getTrialCentres(params = {}) {
    try {
      const response = await api.get('/trial-centres', { params });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch trial centres');
    }
  },

  // Get trial centre by ID
  async getTrialCentre(id) {
    try {
      const response = await api.get(`/trial-centres/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch trial centre');
    }
  },

  // Create new trial centre
  async createTrialCentre(centreData) {
    try {
      console.log('📤 Creating trial centre with payload:', centreData);
      const response = await api.post('/trial-centres', centreData);
      console.log('✅ Trial centre created successfully:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Failed to create trial centre:', error);
      throw new Error(error.response?.data?.message || 'Failed to create trial centre');
    }
  },

  // Update trial centre
  async updateTrialCentre(id, centreData) {
    try {
      const response = await api.put(`/trial-centres/${id}`, centreData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update trial centre');
    }
  },

  // Delete trial centre
  async deleteTrialCentre(id) {
    try {
      console.log('🗑️ Deleting trial centre with ID:', id);
      const response = await api.delete(`/trial-centres/${id}`);
      console.log('✅ Trial centre deleted successfully:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Failed to delete trial centre:', error);
      throw new Error(error.response?.data?.message || 'Failed to delete trial centre');
    }
  },

  // Trial Centre Assignments endpoints

  // Get trial centre assignments
  async getTrialCentreAssignments(trialCentreId, params = {}) {
    try {
      console.log('📋 Fetching trial centre assignments for ID:', trialCentreId);
      const response = await api.get(`/trial-centres/${trialCentreId}/assignments`, { params });
      console.log('✅ Trial centre assignments fetched successfully:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Failed to fetch trial centre assignments:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch trial centre assignments');
    }
  },

  // Create trial centre assignment
  async createTrialCentreAssignment(trialCentreId, assignmentData) {
    try {
      console.log('📤 Creating trial centre assignment for ID:', trialCentreId, 'with data:', assignmentData);
      const response = await api.post(`/trial-centres/${trialCentreId}/assignments`, assignmentData);
      console.log('✅ Trial centre assignment created successfully:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Failed to create trial centre assignment:', error);
      throw new Error(error.response?.data?.message || 'Failed to create trial centre assignment');
    }
  },

  // Update trial centre assignment
  async updateTrialCentreAssignment(trialCentreId, assignmentId, assignmentData) {
    try {
      console.log('📝 Updating trial centre assignment:', trialCentreId, assignmentId, 'with data:', assignmentData);
      const response = await api.put(`/trial-centres/${trialCentreId}/assignments/${assignmentId}`, assignmentData);
      console.log('✅ Trial centre assignment updated successfully:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Failed to update trial centre assignment:', error);
      throw new Error(error.response?.data?.message || 'Failed to update trial centre assignment');
    }
  },

  // Delete trial centre assignment
  async deleteTrialCentreAssignment(trialCentreId, assignmentId) {
    try {
      console.log('🗑️ Deleting trial centre assignment:', trialCentreId, assignmentId);
      const response = await api.delete(`/trial-centres/${trialCentreId}/assignments/${assignmentId}`);
      console.log('✅ Trial centre assignment deleted successfully:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Failed to delete trial centre assignment:', error);
      throw new Error(error.response?.data?.message || 'Failed to delete trial centre assignment');
    }
  }
};
